import { Typography } from "@mui/material";

const EmailNotificationsPageHeader = (): JSX.Element => {
  return <Typography variant="h5">Email Notifications</Typography>;
};

export default EmailNotificationsPageHeader;
